import { CaretDown } from '@phosphor-icons/react';

const btn = {
  primary: 'bg-ink text-white hover:bg-ink/90',
  secondary: 'border border-paper-border2 text-ink hover:bg-paper-muted',
  ghost: 'text-ink-muted hover:bg-paper-muted',
  destructive: 'bg-status-escalated/10 text-status-escalated hover:bg-status-escalated/15',
};
export function Button({ variant = 'primary', className = '', children, ...p }) {
  return <button className={`inline-flex items-center gap-2 rounded-field px-4 py-2 text-sm font-semibold transition ${btn[variant]} ${className}`} {...p}>{children}</button>;
}

export function Card({ className = '', children, ...p }) {
  return <div className={`rounded-card border border-paper-border bg-paper-panel shadow-soft ${className}`} {...p}>{children}</div>;
}

export function Field({ label, required, children, hint }) {
  return (
    <label className="block">
      <span className="mb-1.5 block text-xs text-ink-faint">{label}{required && ' *'}</span>
      {children}
      {hint && <span className="mt-1 block text-[11px] text-ink-faint">{hint}</span>}
    </label>
  );
}

export function TextInput({ dir, className = '', ...p }) {
  return <input dir={dir} className={`w-full rounded-field border border-paper-border2 bg-paper px-3 py-2.5 text-sm text-ink outline-none focus:border-ink ${className}`} {...p} />;
}

export function Select({ value, className = '', children, ...p }) {
  return (
    <div className={`flex items-center justify-between rounded-field border border-paper-border2 bg-paper px-3 py-2.5 text-sm text-ink ${className}`} {...p}>
      <span>{value ?? children}</span><CaretDown size={13} className="text-ink-faint" />
    </div>
  );
}

export function Tabs({ tabs, active, onChange }) {
  return (
    <div className="flex gap-5 border-b border-paper-border">
      {tabs.map((t) => (
        <button key={t.key} onClick={() => onChange?.(t.key)}
          className={`-mb-px pb-2.5 text-sm ${active === t.key ? 'border-b-2 border-ink font-semibold text-ink' : 'text-ink-muted'}`}>
          {t.label}
        </button>
      ))}
    </div>
  );
}

export function Toggle({ on }) {
  return (
    <span className={`flex h-6 w-11 items-center rounded-full p-0.5 ${on ? 'justify-end bg-status-resolved' : 'justify-start bg-paper-border2'}`}>
      <span className="h-5 w-5 rounded-full bg-white" />
    </span>
  );
}
